import Image from 'next/image'
import { HeroValueProps } from '@interfaces/aboutUs'
import { useElementVisible } from '@hooks/useElementVisible'
import styles from './Hero.module.scss'

export const Values = ({ feature, index }: HeroValueProps) => {
  const valueSection = useElementVisible({ threshold: 0.2 })

  return (
    <div
      ref={valueSection.ref}
      key={index}
      className={`${styles.entry} ${valueSection.isVisible ? styles.animate : ''}`}>
      <Image src={feature.icon} className={styles.valueImage} alt={feature.title} width={48} height={48} />
      <span className={styles.cardHeading}>{feature.title}</span>
      <span className={styles.cardSubHeading}>{feature.description}</span>
    </div>
  )
}
